<div class="container" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".map-frame">
  <div class="modal-header mb-4" cdkDragHandle>
    <h5 *ngIf="!data?.id">{{ 'map.sidebar.psa.node.title_new' | translate }}</h5>
    <h5 *ngIf="!!data?.id">{{ 'map.sidebar.psa.node.title_edit' | translate }} - {{ data?.search_term }}</h5>
  </div>

  <div class="modal-body">
    <div class="container scrollable-container">
      <form [formGroup]="nodeForm" (ngSubmit)="onSave()">
        <div class="row pt-1">
          <div class="col-12">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>{{ 'map.sidebar.psa.node.name_label' | translate }}</mat-label>
              <input matInput formControlName="nome" placeholder="{{ 'map.sidebar.psa.node.name_label' | translate }}" />
              <mat-error *ngIf="nodeForm.get('nome')?.hasError('minlength')">Il nome deve contenere almeno 3 caratteri</mat-error>
              <mat-error *ngIf="nodeForm.get('nome')?.hasError('required')">Il nome è obbligatorio</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <mat-form-field *ngIf="!!data?.id" class="w-100" appearance="outline">
              <mat-label>{{ 'map.sidebar.psa.node.type_label' | translate }}</mat-label>
              <input matInput type="text" [value]="data?.tipologia" disabled />
            </mat-form-field>

            <mat-form-field *ngIf="!data?.id" class="w-100" appearance="outline">
              <mat-label>{{ 'map.sidebar.psa.node.type_label' | translate }}</mat-label>
              <mat-select formControlName="tipologia">
                <mat-option *ngFor="let option of typesList" [value]="option.tipologia">{{ option.tipologia }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>{{ 'map.sidebar.psa.node.lat_label' | translate }}</mat-label>
              <input matInput type="number" formControlName="lat" />
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>{{ 'map.sidebar.psa.node.lon_label' | translate }}</mat-label>
              <input matInput type="number" formControlName="lon" />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <mat-form-field class="w-100" appearance="outline">
              <mat-label>{{ 'map.sidebar.psa.node.events_label' | translate }}</mat-label>
              <mat-select formControlName="eventiRischioIds" multiple>
                <mat-option *ngFor="let option of eventsList" [value]="option.id">{{ option.nome }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 align-items-end">
    <button mat-button type="button" (click)="onCancel()">
      {{ 'map.sidebar.psa.node.button_cancel' | translate }}
    </button>
    <button mat-raised-button color="primary" type="submit" (click)="onSave()" [disabled]="nodeForm.invalid">
      {{ 'map.sidebar.psa.node.button_save' | translate }}
    </button>
  </div>
</div>
